<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card">
        <Spinner v-if="isLoading"/>
        <div v-if="!isLoading && customerData" :class="{'datatable-is-loading':customerIsLoading}">
          <Toolbar class="p-mb-4">
            <template #start>
              <div style="font-size: 1.4em; color: inherit">{{ $t('Customer') }}:
                <span>
                  <span v-if="customerData.type === constants.userTypes.legal_entity && customerData.company_name">{{ customerData.company_name }}</span>
                  <span v-else>{{ customerData.first_name }} {{ customerData.last_name }}</span>
                </span>
              </div>
            </template>
            <template #end>
              <span class="p-d-inline-flex"
                    v-tooltip.bottom="billingActionTooltipOptions()">
                 <Button :loading="customerIsLoading"
                         :disabled="disableEditButton || customerIsLoading || billingDataEditingLocked"
                         :label="$t('Edit')"
                         icon="ti-pencil"
                         @click="editItem"
                         class="p-button-success p-button-raised"
                         :class="{ 'p-mr-2':canDelete }"/>
              </span>

              <span class="p-d-inline-flex"
                    v-if="canDelete"
                    v-tooltip.bottom="billingActionTooltipOptions()">
                 <Button class="p-button-raised p-button-warning"
                         icon="ti-trash"
                         :label="$t('Delete')"
                         :disabled="customerIsLoading || deleteButtonDisabled || billingDataEditingLocked"
                         :loading="customerIsLoading"
                         @click="confirmItemDelete"/>
              </span>
            </template>
          </Toolbar>

          <TabMenu :model="tabMenuItems" class="p-p-1"/>

          <router-view @update-items="updateItems"
                       :customerIsLoading="customerIsLoading"
                       :user="customerData"
                       @change-customer-status="changeCustomerStatus"/>

          <CustomerModal :visible="itemModal"
                         :item="item"
                         @update-items="updateItems"
                         @close="closeItemModal"/>
        </div>
        <div v-else-if="!isLoading && !customerIsLoading && !customerData" class="empty-page">{{ $t('No data available') }}</div>
			</div>

      <ConfirmDeleteModal :visible="confirmItemDeleteModal"
                          :modalDataIsLoading="modalDataIsLoading"
                          @close="closeConfirmItemDeleteModal"
                          @delete-item="deleteItem"
                          :data="itemToDeleteData"/>

		</div>
	</div>
</template>

<script>
import httpClient from '@/services/http.services'
import settings from '@/settings.js'
import constants from '@/constants'
import CustomerModal from '@/pages/users/components/CustomerModal'
import httpMixins from '@/mixins/httpMixins'
import showErrorsMixins from "@/mixins/showErrorsMixins";
import datatableMixins from "@/mixins/datatableMixins";
import labelMixin from "@/mixins/labelMixin";
import billingRestrictionsMixin from '@/mixins/billingRestrictionsMixin'

export default {
  mixins: [ httpMixins, showErrorsMixins, datatableMixins, labelMixin, billingRestrictionsMixin ],
  components: { CustomerModal },
	data() {
		return {
      // selectedCustomer: { id: null },
      disableEditButton: false,
      customerIsLoading: false,
      itemModal: false,
      item: null,
      userId: null,
      isLoading: true,
      customerData: null,
      tabMenuItems: [],
      constants
    }
	},
  watch: {
    // '$route'() {
    //   const route = this.$route.path.split('/')
    //   if (this.$route.path === '/login' || route.indexOf('customers') === -1 || route.indexOf(this.$route.params.uid) === -1) {
    //     return false
    //   }
    // },
    '$i18n.locale'() {
      if (this.customerData) {
        this.generateTabMenu()
      }
    },
    '$store.state.firstLayerIsOpened'() {
      if (!this.$store.state.firstLayerIsOpened) {
        if (this.itemModal) {
          this.closeItemModal()
        }
        if (this.confirmItemDeleteModal) {
          this.closeConfirmItemDeleteModal()
        }
      }
    },
  },
  mounted() {
    window.scrollTo(0, 0)
    if (settings.autoLogoutTimeout && this.$store.state.logoutTimestampIsOverdue) return false
    this.getPageData()
	},
  methods: {
    getPageData() {
      this.getCustomerData()
    },
    changeCustomerStatus(newStatus) {
      if (this.customerData) {
        if (this.customerData.customerStatus) {
          this.customerData.customerStatus.status_id = newStatus
        } else {
          this.customerData.customerStatus = {}
          this.customerData.customerStatus.status_id = newStatus
        }
      }
    },
    editItem() {
      if (this.billingActionIsRestricted()) return

      if (this.customerData) {
        this.item = this.customerData
        this.itemModal = true
        this.$store.commit('toggleFirstLayer', true)
      }
    },
    updateItems() {
      this.getCustomerData(false)
    },
    closeItemModal() {
      this.itemModal = false
      if (this.$store.state.firstLayerIsOpened === true ) {
        this.$store.commit('toggleFirstLayer', false)
      }
      this.item = null
      this.submitted = false
    },
    generateTabMenu() {
      this.tabMenuItems = [
        {label: this.$t('General information'), icon: 'ti-info-alt', to: `/customers/${this.$route.params.uid}/overview`},
        {label: this.$t('Orders') + ` (${this.customerData?.ordersCount || 0})`, icon: 'ti-hummer', to: `/customers/${this.$route.params.uid}/orders`},
        {label: this.$t('Offers') + ` (${this.customerData?.offersCount || 0})`, icon: 'ti-clipboard', to: `/customers/${this.$route.params.uid}/estimates`},
        {
          label: (this.$store.getters.isForkliftTenant ? this.$t('Equipment') : this.$t('Cars')) + ` (${this.customerData?.carsCount || 0})`,
          icon: (this.$store.getters.isForkliftTenant ?'ti-truck' : 'ti-car'), to: `/customers/${this.$route.params.uid}/vehicles`
        },
      ]

        if (+this.customerData?.representativesCount > 0) {
        // { label: `Representatives (${this.customerData.representativesCount || 0})`, icon: 'ti-user', to: `/customers/${this.$route.params.uid}/estimates`},
        this.tabMenuItems.push(
            {
              label: `${this.$t('Representatives')} (${this.customerData?.representativesCount ?? 0})`,
              icon: 'ti-user',
              to: `/customers/${this.$route.params.uid}/representatives`
            }
        )
      }

      if (+this.customerData?.representedCompaniesCount > 0) {
        this.tabMenuItems.push({
          label: `${this.$t('Companies')} (${this.customerData?.representedCompaniesCount})`,
          icon: 'ti-briefcase',
          to: `/customers/${this.$route.params.uid}/represented-companies`
        })
      }
    },
    async getCustomerData(showSpinner = true) {
      if (!this.$route.params.uid) return
      if (!this.userCanGetData || this.customerIsLoading) return
      this.isLoading = showSpinner
      this.customerIsLoading = true

      const ctrl = this.setController?.('customerData')
      try {
        const { status, data } = await httpClient({
          url: 'user/get-by-uid',
          method: 'post',
          params: {
            expand:
                'creator,' +
                'updatedBy,' +
                'tax,' +
                'ordersCount,' +
                'offersCount,' +
                'carsCount,' +
                'address.country,' +
                'customerStatus,' +
                'primaryRepresentative.customerStatus,' +
                'representativesCount,' +
                'representedCompaniesCount,' +
                'creationLocationName,'
          },
          data: { uid: this.$route.params.uid },
          signal: ctrl?.signal
        })

        if (status === 200 && data && data.success && data.item) {
          this.customerData = data.item
          // console.log('getCustomerData id: ', data.id)
          this.generateTabMenu()
        } else {
          this.showUnknownError()
          this.customerData = null
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.disableEditButton = false
        this.customerIsLoading = false
        this.isLoading = false
        if (this._abortors?.customerData === ctrl) {
          this._abortors.customerData = null
        }
      }
    },
    async deleteItem() {
      if (this.billingActionIsRestricted()) return

      if (!this.customerData?.id || !this.$store.getters.userCanGetData) return
      this.modalDataIsLoading = true
      this.dataTableIsLoading = true
      try {
        const { status, data } = await httpClient.post('user/delete', { id: this.customerData.id })
        if (status === 200 && data?.success) {
          this.$toast.add({severity:'success', detail: this.$t('Data deleted'), life: settings.toastLife});
          this.closeConfirmItemDeleteModal()
          this.customerData = null
        } else {
          this.showUnknownError()
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.modalDataIsLoading = false
        this.dataTableIsLoading = false
      }
    },
	},
  computed: {
    itemToDeleteData() {
      if (!this.customerData) return null
      return this.getCustomerLabel(this.customerData)
    },
    canDelete() {
      return this.$store.getters.isAdminOrHigher
    },

    deleteButtonDisabled() {
      if (!this.customerData) return true

      const targetId = Number(this.customerData.id || 0)
      const currentId = Number(this.$store.getters.userData?.id || 0)

      return targetId === currentId || !this.$store.getters.isAdminOrHigher
    }
  }
}
</script>